<svelte:options accessors/>
<script lang="ts">
    import NauiSlideOver from "../../naui/layout/NauiSlideOver.svelte";

    export let open = false;
</script>
<NauiSlideOver bind:open={open} maxWidth="400px" title="Formas de pago">
    <div class="back-gray p-1 radius">
        <div class="mb-1">
            <strong class="block mb-ii">Pago electrónico</strong>
            <p>Puede realizar el pago de forma electrónica seleccionando las obligaciones que requiere en las casillas
                de la
                columna izquierda, y posteriormente el botón Continuar a pago. Puede realizar varios pagos en una sola
                transacción seleccionando los diferentes obligaciones.</p>
            <div class="box py-1">
                <img height="100" src="{window['baseStatic']}pagos_app/pix/img-pago-electronico.svg">

            </div>
        </div>
        <div>
            <strong class="block mb-ii">Pago en bancos</strong>
            <p>Para pago en bancos imprima el recibo de pago seleccionando la opción de la columna: El recibo de pago en
                banco. Si quiere realizar varios pagos, deberá imprimir el recibo correspondiente a cada obligación. Aplica solo para pólizas cuya fecha límite de pago no está vencida.</p>
            <div class="box py-1">
                <img height="100" src="{window['baseStatic']}pagos_app/pix/img-pago-bancos.svg">
            </div>
        </div>
    </div>
</NauiSlideOver>